import logo from '../Assets/coursebook_logo.png';

const Header = () => {
  return (
    <header className='logo'>
        <img src={logo} alt="Coursebook Logo" />
    </header>
  )
}

export default Header